import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

import { ProviderMention } from '../../../services/types/treatment-types';
import { ArtifactCitationCard } from '../../artifact-citation-card/ArtifactCitationCard';

interface ProviderMentionsListProps {
  mentions: ProviderMention[];
  expandedByDefault?: boolean;
}

export const ProviderMentionsList = ({
  mentions,
  expandedByDefault = false,
}: ProviderMentionsListProps) => {
  const [isExpanded, setIsExpanded] = useState(expandedByDefault);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  if (mentions.length === 0) {
    return null;
  }

  return (
    <div>
      {!expandedByDefault && (
        <button
          type="button"
          onClick={handleToggle}
          className="text-left flex items-center justify-between py-2 text-xs font-medium text-muted-foreground hover:text-foreground focus:outline-none transition-colors group"
          aria-expanded={isExpanded}
        >
          <div className="flex items-center gap-1.5">
            <span className="text-zinc-700 dark:text-zinc-300">
              {isExpanded ? 'Sources' : `Sources (${mentions.length})`}
            </span>
          </div>
          <div className="text-zinc-40 px-1 group-hover:text-zinc-600 dark:group-hover:text-zinc-300 transition-colors">
            {isExpanded ? (
              <ChevronUpIcon className="h-3.5 w-3.5" />
            ) : (
              <ChevronDownIcon className="h-3.5 w-3.5" />
            )}
          </div>
        </button>
      )}

      {isExpanded && (
        <div className="mt-1.5">
          <div>
            {mentions.map((mention) => (
              <ArtifactCitationCard
                key={mention.id}
                artifactId={mention.artifact_id}
                artifactType={mention.artifact_type}
                excerpts={mention.excerpts}
                reasoning={mention.reasoning}
                confidenceScore={mention.confidence}
                initialExcerptCount={1}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
